import {
    getModule,
    Module,
    MutationAction,
    VuexModule
  } from "vuex-module-decorators";
  import store from "@/store";
  import { GetResponse } from "@/api/genre/response";
  import * as GenreAPI from "@/api/genre";
  import { isSuccess } from "@/api/response";
  
  const MODULE_NAME = "genre/get";
  
  /**
   * 都道府県情報取得API（/get-genre）のレスポンスを管理するストアモジュール
   */
  @Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
  class Get extends VuexModule {
    // genre
    getResponse: GetResponse = {} as GetResponse;
    // getters
    get isSuccess() {
      return isSuccess(this.getResponse);
    }
  
    get getMessage() {
      return this.getResponse.message;
    }
  
    get getItems() {
      if (this.getResponse.results) {
        return this.getResponse.results.items || [];
      } else {
        return [];
      }
    }
  
    // MutationActions
    @MutationAction
    async get() {
      const getResponse = await GenreAPI.get();
      return {
        getResponse
      };
    }
  
    @MutationAction
    async clearResponse() {
      return {
        getResponse: {} as GetResponse
      };
    }
  }
  
  export default getModule(Get);
  